import React from 'react'

export const StartPageHomeHandler = React.lazy(
  () => import('@freckle/student/ts/common/components/navigation/start-page-home')
)
export const SelectLoginPageHandler = React.lazy(
  () => import('@freckle/student/ts/common/components/navigation/select-login')
)
export const StartPageAssignmentsHandler = React.lazy(
  () => import('@freckle/student/ts/common/components/navigation/start-page-assignments')
)
export const StorePageHandler = React.lazy(
  () => import('@freckle/student/ts/common/components/navigation/store/index')
)
export const StorePageDebugHandler = React.lazy(
  () => import('@freckle/student/ts/common/components/navigation/store/debug')
)
export const StoreClosedPageHandler = React.lazy(
  () => import('@freckle/student/ts/common/components/navigation/store/store-closed')
)
export const StoreOpenPageHandler = React.lazy(
  () => import('@freckle/student/ts/common/components/navigation/store/store-open')
)
export const ChangeThemeHandler = React.lazy(
  () => import('@freckle/student/ts/common/components/navigation/change-theme/index')
)
export const DebugDepthOfKnowledgeHandler = React.lazy(
  () => import('@freckle/student/ts/math/depth-of-knowledge/components/debugger')
)
export const AssignmentNotFoundHandler = React.lazy(
  () => import('@freckle/student/ts/common/components/common/assignment-not-found')
)
export const AssignmentErrorHandler = React.lazy(
  () => import('@freckle/student/ts/common/components/common/assignment-error')
)
export const DebuggersPageHandler = React.lazy(
  () => import('@freckle/student/ts/pages/debuggers/components/index')
)
export const LoginHandler = React.lazy(
  () => import('@freckle/student/ts/common/components/navigation/login/index')
)
export const VideoPlayerHandler = React.lazy(
  () => import('@freckle/student/ts/common/components/video-player')
)
export const LoginQrHandler = React.lazy(
  () => import('@freckle/student/ts/common/components/navigation/login/login-qr-handler')
)
export const DirectLoginHandler = React.lazy(
  () => import('@freckle/student/ts/common/components/navigation/login/direct-login-handler')
)
export const SignoutHandler = React.lazy(
  () => import('@freckle/student/ts/common/components/navigation/signout')
)
export const ClassCodeHelpPage = React.lazy(
  () => import('@freckle/student/ts/pages/class-code-help-page')
)
export const MathViewerHandler = React.lazy(
  () => import('@freckle/student/ts/math/internal/debuggers/math-viewer')
)
export const OnboardingPageHandler = React.lazy(
  () => import('@freckle/student/ts/pages/onboarding/components/index')
)
